














import {Component, Vue} from "vue-property-decorator";
import Database from "@/modules/firebase";

@Component
class ShowAccess extends Vue {
    private active?: boolean | null;
    private title?: string;
    private description?: string;
    private token: any;
    private error: string | null;
    private flip: boolean;
    private snapshot: any;

    constructor() {
        super();
        this.active = null;
        this.flip = false;
        this.error = null;
        this.snapshot = null;
    }

    beforeMount() {
        const {token} = this.$route.query;
        if (!token) {
            this.error = "Token missed";
        } else {
            this.token = token;
        }
    }

    mounted() {
        if (this.error === null) {
            const data = Database.getTokenData(this.token);
            data.on('value', (snapshot: any) => {
                if (snapshot.val() === null) {
                    this.error = "Token invalid";
                    this.$forceUpdate();
                }
                this.snapshot = snapshot.val();
                const {status, settings} = snapshot.val();
                if(settings && settings.statusSettings && settings.statusSettings.go.iconDirection == 'right'){
                    this.flip = true;
                }

                this.setStatus(status);
                this.$forceUpdate();
            });
        }
    }

    setStatus(status: boolean) {
        this.active = status;

        if (status) {
            this.title = this.snapshot.settings && this.snapshot.settings.messages && this.snapshot.settings.messages.go.title || 'Bitte einzeln eintreten';
            this.description = this.snapshot.settings && this.snapshot.settings.messages && this.snapshot.settings.messages.go.description || 'Bitte treten Sie gemeinsam mit Ihrer Begleitung (Kinder, etc) ein.';
            if (this.active && this.snapshot.settings &&  this.snapshot.settings.statusSettings && this.snapshot.settings.statusSettings.go && this.snapshot.settings.statusSettings.go.notificationSoundEnabled) {
                if (this.token == 'M3VAfJM0eACN5w4r006YVCs8oG2kBL') {
                    const audio = new Audio(require('@/assets/sounds/schliecker-fleisch-wursttresen.wav'))
                    audio.play()
                } else if(this.token == 'rbwdv7P3UO36Cu3Qhb2pMDOkJMEXDg') {
                    const audio = new Audio(require('@/assets/sounds/schliecker-heise-theke.wav'))
                    audio.play()
                } else if(this.token == 'crjhsw1ZuIaoj95D0nKIhQZBaNlXk2') {
                    const audio = new Audio(require('@/assets/sounds/schliecker-heise-theke.wav'))
                    audio.play()
                } else {
                    const audio = new Audio(require('@/assets/sounds/classic-whistle.mp3'))
                    audio.play()
                }
            }
        } else {
            this.title = this.snapshot.settings && this.snapshot.settings.messages && this.snapshot.settings.messages.stop.title || 'Bitte warten';
            this.description = this.snapshot.settings && this.snapshot.settings.messages && this.snapshot.settings.messages.stop.description || 'Aktuell befinden sich schon viele Menschen in unseren Räumen. \n Bitte warten Sie hier, Sie werden in Kürze eingelassen.';
        }
    }

}

export default ShowAccess;
